import React, { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";

const TabellaRimessiCompleta = () => {
  const [rimessi, setRimessi] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch("./ordini_urgenti.json")
      .then((res) => res.json())
      .then((data) => {
        const datiRaw = data?.RIMESSI?.flat() || [];
        
        const raggruppati = datiRaw.reduce((acc, curr) => {
          const numRimesso = curr["Num Rimesso"];
          if (!acc[numRimesso]) {
            acc[numRimesso] = { 
              ...curr, 
              listaBem: [curr["ID BEM"]] 
            };
          } else {
            if (!acc[numRimesso].listaBem.includes(curr["ID BEM"])) {
              acc[numRimesso].listaBem.push(curr["ID BEM"]);
            }
          }
          return acc;
        }, {});

        setRimessi(Object.values(raggruppati));
        setLoading(false);
      })
      .catch((err) => {
        console.error("Errore:", err);
        setLoading(false);
      });
  }, []);

  const getRowStyle = (dateString) => {
    if (!dateString) return { borderLeft: "4px solid #e0e0e0" };
    const dataR = new Date(dateString.split(' ')[0]);
    const oggi = new Date();
    dataR.setHours(0, 0, 0, 0);
    oggi.setHours(0, 0, 0, 0);
    const diffDays = Math.floor((oggi - dataR) / (1000 * 60 * 60 * 24));

    // Logica colori: Bordeaux (15+), Rosso (7+), Rosa (3+)
    if (diffDays >= 15) return { backgroundColor: "#800020", color: "#fff", borderLeft: "4px solid #4a0012" };
    if (diffDays >= 7) return { backgroundColor: "#ff3e3e", color: "#fff", borderLeft: "4px solid #b30000" };
    if (diffDays >= 3) return { backgroundColor: "#ffd1dc", color: "#000", borderLeft: "4px solid #ff8da1" };
    
    return { backgroundColor: "#ffffff", color: "#333", borderLeft: "4px solid #e0e0e0" };
  };

  return (
    <div className="ombra card tb" style={{ 
        borderRadius: "12px", border: "1px solid #dee2e6", height: "400px", 
        display: "flex", flexDirection: "column", overflow: "hidden", backgroundColor: "#fff" 
    }}>
      <div className="p-3 bg-light border-bottom d-flex justify-content-between align-items-center">
        <span style={{ fontWeight: "700", fontSize: "0.75rem", color: "#495057", letterSpacing: "1px" }}>
            RIMESSI (RAGGRUPPATI)
        </span>
        <span className="badge rounded-pill bg-secondary" style={{ fontSize: "0.65rem" }}>
            {rimessi.length} DOCUMENTI
        </span>
      </div>

      <style>{`
        .scroll-area { overflow-y: auto; flex-grow: 1; }
        .scroll-area::-webkit-scrollbar { width: 6px; }
        .scroll-area::-webkit-scrollbar-thumb { background: #ccc; border-radius: 10px; }
        
        .table-rimessi { margin-bottom: 0; table-layout: fixed; width: 100%; }
        .table-rimessi thead th { 
            position: sticky; top: 0; z-index: 10; 
            background-color: #f8f9fa !important; color: #6c757d !important; 
            font-size: 0.7rem; text-transform: uppercase; padding: 12px 8px;
            border-bottom: 2px solid #dee2e6 !important;
        }
        .table-rimessi tbody td { 
            font-size: 0.75rem; padding: 8px; 
            vertical-align: middle; border-bottom: 1px solid #f2f2f2;
        }
        .bem-pill {
            display: inline-block; background: rgba(0,0,0,0.05);
            padding: 2px 6px; border-radius: 4px; margin: 1px;
            font-size: 0.65rem; font-weight: 600; border: 1px solid rgba(0,0,0,0.1);
        }
        .riga-dark .bem-pill { background: rgba(255,255,255,0.2); border-color: rgba(255,255,255,0.3); color: #fff; }
      `}</style>
      
      <div className="scroll-area ">
        <Table hover className="table-rimessi">
          <thead>
            <tr>
              <th style={{ width: "10%" }}>Dep</th>
              <th style={{ width: "25%" }}>Ragione Sociale</th>
              <th style={{ width: "15%" }}>Data</th>
              <th style={{ width: "15%" }}>Num. Rim</th>
              <th style={{ width: "35%" }}>Lista BEM</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan="5" className="text-center py-5">Caricamento...</td></tr>
            ) : (
              rimessi.map((row, idx) => {
                const style = getRowStyle(row["Data Rimesso"]);
                const isDark = style.color === "#fff";
                return (
                  <tr key={idx} style={style} className={isDark ? "riga-dark" : ""}>
                    <td>{row["Dep"]}</td>
                    <td className="fw-bold" style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                        {row["Ragione Sociale"]}
                    </td>
                    <td>{row["Data Rimesso"]? new Date(row["Data Rimesso"]).toLocaleDateString(
                            "it-IT",
                          )
                        : "-"}{" "}</td>
                    <td>{row["Num Rimesso"]}</td>
                    <td>
                      <div className="d-flex flex-wrap">
                        {row.listaBem.map((bem, i) => (
                          <span key={i} className="bem-pill">{bem}</span>
                        ))}
                      </div>
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </Table>
      </div>
    </div>
  );
};

export default TabellaRimessiCompleta;